/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".resolution-overlay[_ngcontent-%COMP%]{position:fixed;width:100vw;height:100vh;top:0;left:0;right:0;bottom:0;z-index:9999999;background:url(rotate.ce2d2994bfe0add6fb8d.png) center/contain no-repeat #fffbd5;align-items:flex-end;justify-content:center;text-align:center;flex-flow:wrap;display:none}.resolution-overlay[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%]{margin:5vw;font-size:7vw}@media (max-aspect-ratio:1/1){.resolution-overlay[_ngcontent-%COMP%]{display:flex}}"];
export { styles as styles };
